// removed by extract-text-webpack-plugin
module.exports = {"buttonUp":"_3C-bdS2Fwzv59IffnUrzFu","icon":"_3M_2wk0TrHJCmp1mH5cphg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMUpButton/OMUpButton.scss
// module id = 1683
// module chunks = 0